<ng-container *ngIf="field.controlType === 'date'; then date else datetime"></ng-container>

<ng-template #date>
  <mat-form-field appearance="outline">
    <mat-label>{{ field.key | translate }}</mat-label>
    <input matInput [formControl]="field.control" [matDatepickerFilter]="dateFilter" [matDatepicker]="datepicker"
      [transform]="toDbModel.bind(this)" placeholder="{{ field.key | translate }}" />
    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
    <mat-datepicker #datepicker></mat-datepicker>
  </mat-form-field>
</ng-template>

<ng-template #datetime>
  <mat-form-field appearance="outline">
    <mat-label>{{ field.key | translate }}</mat-label>
    <input matInput [formControl]="field.control" [ngxMatDatetimePicker]="datetimepicker"
      [transform]="toDbModel.bind(this)" placeholder="{{ field.key | translate }}" />
    <mat-datepicker-toggle matSuffix [for]="datetimepicker"></mat-datepicker-toggle>
    <ngx-mat-datetime-picker #datetimepicker [showSpinners]="true" [stepHour]="true" [stepMinute]="true">
    </ngx-mat-datetime-picker>
  </mat-form-field>
</ng-template>